module.exports = "/ui/406e9db8d24e628d8e0e7a1cbe72fb21.jpeg";